import { massClrRunQueryOptions } from '@/hooks/queries/credit/useMassClr'
import { queryClient } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../../credit-route-config'

// Layout route for one run: carries the run-reference crumb so the workbench and Review & Submit
// sit under Credit Limit Reviews > Mass Reviews > MR-YYYY-MM-DD in the breadcrumbs.
export const Route = createFileRoute('/_auth/_modules/credit/credit-limit-reviews/mass/$runId')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/credit-limit-reviews/mass/$runId']),
  loader: async ({ params: { runId } }) => {
    const run = await queryClient
      .ensureQueryData(massClrRunQueryOptions(Number(runId)))
      .catch(() => null)
    return { crumb: run?.reference ?? runId }
  },
})
